module.exports = __webpack_public_path__ + "img/icon-info-color.09fe51a2.svg";